import { EQueryIdType } from './types';

export const USER_ID_FIELD = 'app_user_id';
export const CLIENT_ID_FIELD = 'client_id';
export const DEVICE_NAME_FIELD = 'device_name';

export const idOptions = [
  {
    label: 'User ID',
    value: EQueryIdType.userId,
  },
  {
    label: 'Client ID',
    value: EQueryIdType.clientId,
  },
];

export const EmptyArray: any[] = [];
